import { supportedLanguages } from '../config';

// Return RTL for Arabic and LTR for other supported languages.
export const languageDirection = (language) => {
  const selectedLanguage = supportedLanguages.find(
    (item) => item.code === language,
  );

  return selectedLanguage?.direction || 'ltr';
};

export default languageDirection;